import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_notifications-p0_nudge-click';
/**
 * This event tracks clicks on p0 notification nudge
 */
export function trackRetailerNotificationsP0NudgeClick(Notification_Type_string, retailerToken, Message_string2 = '', Notification_Identifier_string3 = '') {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            Notification_Type_string,
            retailerToken,
            Message_string2,
            Notification_Identifier_string3,
        },
    });
}
